export interface IClassNamesUtils {
    [className: string]: boolean;
  }
  
  export const classNames = (classes: IClassNamesUtils) =>
    Object.entries(classes)
      .filter(([_, value]) => value)
      .map(([key]) => key)
      .join(' ');
  